<template>
  <div class="page-content">
    <page-template ref="businessTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :detailColumns="detailColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower'
  import date from '@/mixin/date'

  export default {
    mixins: [userPower, date],
    components: {
      pageTemplate

    },
    data() {
      return {
        dialogVisibility: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            {label: '业务单号', prop: 'orderNo', type: 'input', ifFuzzy: true, placeholder: "请输入业务单号"}
          ],
          complex: [
            {label: "选择日期", prop: "CreateDttm", type: "dateTimeRangeButton", dateType: "datetime", span: 24},
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              span: 12,
              data: [],
              isHasAll: true,
              url: api.system.seStore
            },
            {
              label: '出入库',
              prop: 'type',
              type: "select",
              data: this.$utils.getCacheStatus('weAdjustInventoryOrder.type'),
              span: 12,
            },
            // {
            //   label: "仓库",
            //   type: "select",
            //   prop: "warehouseId",
            //   url: api.warehouse.warehouse,
            //   change: this.getBatchOrder,
            //   param: {relateType: this.$utils.getSysUser().storeId?20:10},
            //   data: [],
            //   span: 12,
            //   disabled: false,
            // },
            {
              label: '审核状态',
              type: 'select',
              prop: 'reviewerStatus',
              defaultValue: 20,
              span: 12,
              data: [
                {label: '未审核', value: 20},
                {label: '已审核', value: 10}
              ],
            },
            {
              label: "原因",
              type: "select",
              prop: "cause",
              span: 12,
              data: this.$utils.getCacheStatus('weAdjustInventoryOrder.cause')
            },
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
            callback: this.addGoods
          },
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
            callback: this.toEditPage,
            filter: (data) => {
              return data.reviewerStatus == 10 ? false : true;
            }
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate,
            filter: (data) => {
              return data.reviewerStatus == 10 ? false : true;
            }
          },
          {
            label: '导出',
            code: 'export',
            callback: this.goodsDetailExport,
            filter: () => {
              return false
            }
          }
        ],
        // 表格信息配置
        tableOptions: {
          indexShow: true,//是否显示索引
          tableName: 'clearTable',
          showSelect: true,
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
              width: '230',
              align: 'center',
              // showDetail: true
              callback: this.goOrderDetail
            },
            {
              label: '出入库',
              prop: 'type',
              width: '100',
              align: 'center',
              enumData: this.$utils.getCacheStatus('weAdjustInventoryOrder.type')
            },
            {label: '仓库名称', prop: 'warehouseName', width: '190', align: 'center'},
            {
              label: '审核状态',
              prop: 'reviewerStatus',
              width: '100',
              align: 'center',
              enumData: this.$utils.getCacheStatus('weAdjustInventoryOrder.reviewerStatus')
            },
            {label: '单据金额', prop: 'totalPrice', width: '100', align: 'center'},
            {label: '制单人', prop: 'voucherName', width: '120', align: 'center'},
            {label: '制单日期', prop: 'voucherDttm', width: '145', align: 'center'},
            {label: '审核人', prop: 'reviewerName', width: '120', align: 'center'},
            {label: '审核日期', prop: 'reviewerDttm', width: '145', align: 'center'},
            {
              label: '原因',
              prop: 'cause',
              width: '80',
              align: 'center',
              enumData: this.$utils.getCacheStatus('weAdjustInventoryOrder.cause'),
            },
            {label: '备注', prop: 'remarks', width: '125', align: 'center'},
          ],
          param: {reviewerStatus: 20, stCreateDttm: this.getStMonthDate(), edCreateDttm: this.getEdMonthDate()},
          url: api.warehouse.adjustInventory
        },
        // 详情
        detailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
            right: '350px',
            top: '30px'
          },
          span: 8,
          labelWidth: "130",
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
              span: 12,
            },
            {
              label: '仓库',
              prop: 'warehouseName',
              span: 12,
            }, {
              label: '原因',
              type: 'select',
              prop: 'cause',
              enumData: this.$utils.getCacheStatus('weAdjustInventoryOrder.cause'),
              span: 12,
            }, {
              label: '出入库',
              type: 'select',
              enumData: this.$utils.getCacheStatus('weAdjustInventoryOrder.type'),
              prop: 'type',
              span: 12,
            }, {
              label: '备注',
              type: 'input',
              prop: 'remarks',
              span: 12,
            }],
          tablesProp: {
            weAdjustGoodsMapMVOList: {
              url: api.warehouse.adjustGoodsMap + "/page",
              height: this.detailHeight,
              indexShow: true,
              tableName: "weAdjustGoodsMapMVOList",
              showSummary: true,
              summaryColumns: ['goodsNum', 'totalPrice'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  type: 'more',
                  callback: this.getInfo,
                  align: 'center',
                  width: '250'
                },
                {
                  label: '商品名称',
                  prop: 'goodsName',
                  align: 'center',
                  width: '250'
                },
                {
                  label: '进货规格',
                  prop: 'specs',
                  align: 'center',
                  width: '250'
                },
                {
                  label: '价格',
                  prop: 'purchasePrice',
                  align: 'center',
                  width: '250'
                },
                {
                  label: '数量',
                  prop: 'goodsNum',
                  type: 'inputNumber',
                  change: this.numChange,
                  align: 'center',
                  width: '250'
                },
                {
                  label: '小计金额',
                  prop: 'totalPrice',
                  align: 'center',
                  width: '250'
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '300',
                  align: 'center'
                },
              ],
            }
          },

          printTablesProp: {
            weAdjustGoodsMapMVOList: {
              tableName: 'weAdjustGoodsMapMVOList',
              showSummary: true,
              summaryColumns: ['goodsNum', 'totalPrice'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  type: 'more',
                  callback: this.getInfo,
                  align: 'center',
                  width: '250'
                },
                {
                  label: '商品名称',
                  prop: 'goodsName',
                  align: 'center',
                  width: '250'
                },
                {
                  label: '进货规格',
                  prop: 'specs',
                  align: 'center',
                  width: '250'
                },
                {
                  label: '价格',
                  prop: 'purchasePrice',
                  align: 'center',
                  width: '250'
                },
                {
                  label: '数量',
                  prop: 'goodsNum',
                  type: 'inputNumber',
                  change: this.numChange,
                  align: 'center',
                  width: '250'
                },
                {
                  label: '小计金额',
                  prop: 'totalPrice',
                  align: 'center',
                  width: '250'
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '300',
                  align: 'center'
                },
              ],
            },
          },
          url: api.warehouse.adjustInventory
        }
      };
    },
    created() {
      this.setStore(this.searchOptions.complex)
      this.$nextTick(() => {
        this.$refs['businessTemplate'].operationSuccess();
      })
    },
    mounted() {
      if (Object.keys(this.$route.params).length > 0) {
        if (this.$route.params.customQuery) {
          let str = this.$route.params.customQuery
          this.tableOptions.param = eval('(' + str + ')')
        }
      }
      // this.$nextTick(()=>{
      //   this.tableOptions.url = api.warehouse.adjustInventory
      //   this.$refs['businessTemplate'].operationSuccess();
      // })
    },
    methods: {
      goOrderDetail(row) {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.detailColumns);
        this.$router.push({
          path: '/warehouse/business/detail?id=' + row.id,
          query: {redirect: '/warehouse/business'}
        }).catch(err => {
        });
      },
      addGoods() {
        this.$router.push({path: '/warehouse/business/add'});
      },
      toEditPage(row) {
        this.$router.push({path: '/warehouse/business/add?id=' + row.id});
      },
      goodsDetailExport() {
        let selectData = this.$refs["businessTemplate"].$refs["tableTemp"].selectRow;
        if (selectData.length === 0) {
          this.$confirm('请选择一条数据！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
        } else {
          if (selectData.length > 1) {
            this.$confirm('只能选择一条数据！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$refs["businessTemplate"].$refs["tableTemp"].$refs["clearTable"].clearSelection();
            })
          } else {
            this.$axios.fetchPost(api.warehouse.businessGoodsExport, {
              id: selectData[0].id,
              exportCode: 'WeAdjustInventoryGoodsExport'
            }).then(data => {
              if (data.code === 200) {
                const elink = document.createElement('a');
                elink.href = data.data;
                elink.click();
                this.loadingExt = false;
                this.$notify({
                  type: "success",
                  title: '导出操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({message: '导出成功', type: 'success'});
              } else {
                this.$notify({
                  type: "error",
                  title: '导出操作',
                  message: '失败',
                  showClose: false,
                });
                // this.$message({message: '导出异常', type: 'error'});
              }
            })
          }
        }
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/warehouse/Business.vue